import React from 'react';
import Svg, { Circle, Defs, G, LinearGradient as SvgLinearGradient, Path, Stop } from 'react-native-svg';
import { HOME_PETAL_PATHS } from './homeDirectionArtwork';

// Keep the approved six-petal geometry; palette belongs to the Apricot Pearl kit.
export const DesktopLotusSkeleton: React.FC<{
  activePetal: number | null;
  isDark: boolean;
  selectedPetal: number | null;
}> = ({ activePetal, isDark, selectedPetal }) => {
  // A retained navigation screen must never share SVG paint servers with another
  // flower. Theme-specific IDs also invalidate cached paint references on switch.
  const instanceId = React.useId().replace(/[^a-zA-Z0-9_-]/g, '');
  const prefix = `home-lotus-${instanceId}-${isDark ? 'dark' : 'light'}`;
  const petalId = `${prefix}-petal`;
  const centerId = `${prefix}-center`;
  const dividerId = `${prefix}-divider`;
  const edgeId = `${prefix}-edge`;
  return (
    <Svg key={prefix} width="100%" height="100%" viewBox="0 0 534 416">
      <Defs>
        <SvgLinearGradient id={petalId} gradientUnits="objectBoundingBox" x1="0%" y1="0%" x2="0%" y2="100%">
          <Stop offset="0" stopColor={isDark ? '#7E9188' : '#FFF9DC'} />
          <Stop offset="1" stopColor={isDark ? '#354B60' : '#A7C5BC'} />
        </SvgLinearGradient>
        <SvgLinearGradient id={centerId} gradientUnits="objectBoundingBox" x1="0%" y1="0%" x2="0%" y2="100%">
          <Stop offset="0" stopColor={isDark ? '#84665F' : '#FFF8DF'} />
          <Stop offset="0.42" stopColor={isDark ? '#785D61' : '#FFF0CF'} />
          <Stop offset="0.54" stopColor={isDark ? '#6D5660' : '#FFE8CC'} />
          <Stop offset="1" stopColor={isDark ? '#594D5A' : '#FFD9BA'} />
        </SvgLinearGradient>
        <SvgLinearGradient id={dividerId} gradientUnits="objectBoundingBox" x1="0%" y1="0%" x2="100%" y2="0%">
          <Stop offset="0" stopColor={isDark ? '#AF8A77' : '#AA7847'} stopOpacity={0} />
          <Stop offset="0.5" stopColor={isDark ? '#AF8A77' : '#AA7847'} stopOpacity={0.33} />
          <Stop offset="1" stopColor={isDark ? '#AF8A77' : '#AA7847'} stopOpacity={0} />
        </SvgLinearGradient>
        <SvgLinearGradient id={edgeId} gradientUnits="objectBoundingBox" x1="0%" y1="0%" x2="100%" y2="100%">
          <Stop offset="0" stopColor="#FF7138" />
          <Stop offset="0.5" stopColor="#FF9A62" />
          <Stop offset="1" stopColor="#F6C5A7" />
        </SvgLinearGradient>
      </Defs>
      {HOME_PETAL_PATHS.map((path, index) => (
        <G key={index}>
          <Path d={path} fill={isDark ? '#7E9188' : '#FFF9DC'} />
          <Path d={path} fill={`url(#${petalId})`} stroke={isDark ? '#E98245' : `url(#${edgeId})`} strokeOpacity={selectedPetal === index ? 1 : 0.65} strokeWidth={selectedPetal === index ? 3 : 1.45636} />
          <Path testID={`home-petal-hint-${index}`} d={path} fill={isDark ? '#FFF0BD' : '#FFFBDD'} fillOpacity={selectedPetal === index ? (isDark ? 0.30 : 0.65) : activePetal === index ? 0.16 : 0} />
        </G>
      ))}
      <Circle cx="265.786" cy="202.68" r="83.741" fill={isDark ? '#84665F' : '#FFF8DF'} />
      <Circle cx="265.786" cy="202.68" r="83.741" fill={`url(#${centerId})`} stroke={isDark ? '#E98245' : `url(#${edgeId})`} strokeWidth={1.82045} />
      <Path d="M202.677 201.467H328.895" stroke={`url(#${dividerId})`} strokeWidth={0.910227} />
    </Svg>
  );
};
